if (!customElements.get('tom-event-reservation')) {
  customElements.define('tom-event-reservation', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const params = new URLSearchParams(location.search);
      const date = params.get('event_date');
      const sectionId = params.get('calendar_section');
      if (!date && !sectionId) return;
      this.hidden = false;
      this.main = this.closest('[id^="MainProduct-"]');
      this.status = this.querySelector('[data-reservation-status]');
      this.status.textContent = this.dataset.loading;
      this.valid = false;
      this.abort = new AbortController();
      this.main.addEventListener('submit', event => {
        if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
        if (!this.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.status.focus();
        } else this.applyProperties();
      }, {capture:true, signal:this.abort.signal});
      const buttons = Array.from(this.main.querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"]'));
      this.buttons = buttons.map(button => ({button,disabled:button.disabled}));
      this.buttons.forEach(item => { item.button.disabled = true; });
      this.main.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = true; });
      try {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '') || !/^[a-zA-Z0-9_-]{1,160}$/.test(sectionId || '') || !/(?:^|__)tom_event_calendar$/.test(sectionId)) throw new Error('invalid');
        const url = new URL(this.dataset.root,location.origin);
        url.searchParams.set('section_id',sectionId);
        if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
        const response = await fetch(url.href,{credentials:'same-origin',signal:this.abort.signal});
        if (!response.ok) throw new Error('calendar');
        const html = await response.text();
        const page = new DOMParser().parseFromString(html,'text/html');
        const calendar = page.querySelector('tom-event-calendar');
        const template = calendar && calendar.querySelector('[data-event-cards]');
        const card = template && Array.from(template.content.children).find(item => item.dataset.eventDate === date && item.dataset.eventProduct === this.dataset.product);
        if (!card || !card.querySelector('[data-event-booking]')) throw new Error('date');
        const zone = calendar.dataset.timezone || 'America/New_York';
        const nowParts = new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const today = ['year','month','day'].map(key => nowParts.find(part => part.type === key).value).join('-');
        const currentTime = new Intl.DateTimeFormat('en-GB',{timeZone:zone,hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(new Date());
        if (date < today || (date === today && card.dataset.eventAllDay !== 'true' && card.dataset.eventTime && card.dataset.eventTime < currentTime)) {
          this.status.textContent = this.dataset.past;
          return;
        }
        const parts = date.split('-').map(Number);
        const dateLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'en',{weekday:'long',year:'numeric',month:'long',day:'numeric',timeZone:'UTC'}).format(new Date(Date.UTC(parts[0],parts[1]-1,parts[2],12)));
        this.properties = {
          'Event':card.dataset.eventTitle,
          'Event date':dateLabel+' ('+date+')',
          'Event time':card.dataset.eventTimeLabel+(card.dataset.eventAllDay === 'true' ? '' : ' · '+this.dataset.eastern)
        };
        this.status.textContent = card.dataset.eventTitle+' · '+dateLabel+' · '+this.properties['Event time'];
        this.valid = true;
        this.applyProperties();
        this.buttons.forEach(item => { if (item.button.isConnected) item.button.disabled = item.disabled; });
        this.main.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = false; });
        this.observer = new MutationObserver(() => this.applyProperties());
        this.observer.observe(this.main,{childList:true,subtree:true});
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
      }
    }
    applyProperties() {
      if (!this.valid) return;
      this.main.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
        Object.entries(this.properties).forEach(([key,value]) => {
          const name = 'properties['+key+']';
          let input = Array.from(form.elements).find(item => item.name === name);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            form.append(input);
          }
          if (input.value !== value) input.value = value;
        });
      });
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      this.initialized = false;
    }
  });
}

